import "./chunk-EUXUH3YW.js";

// libs/ui-components/src/lib/modules/icon/icons/globe_24.svg.ts
import { svg } from "lit";
var globe24Svg = svg`
<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
  <g clip-path="url(#clip0_6716_6247)">
    <path d="M12 22.5C17.799 22.5 22.5 17.799 22.5 12C22.5 6.20101 17.799 1.5 12 1.5C6.20101 1.5 1.5 6.20101 1.5 12C1.5 17.799 6.20101 22.5 12 22.5Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M1.5 12H22.5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M12 1.5C14.8139 4.37527 16.4131 8.10664 16.5 12C16.4131 15.8934 14.8139 19.6247 12 22.5C9.18606 19.6247 7.5869 15.8934 7.5 12C7.5869 8.10664 9.18606 4.37527 12 1.5V1.5Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
  </g>
  <defs>
    <clipPath id="clip0_6716_6247">
      <rect width="24" height="24" fill="white"/>
    </clipPath>
  </defs>
</svg>
`;
export {
  globe24Svg
};
//# sourceMappingURL=globe_24.svg-3EBQMDCF.js.map
